import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function AlertCards({ color, icon, title, count, description, onClick }) {
  return (
    <Card
      onClick={onClick}
      sx={{
        position: "relative",
        cursor: "pointer",
        transition: "0.2s",
        "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
      }}
    >
      {count ? (
        <MDBox
          sx={{
            position: "absolute",
            top: 8,
            right: 12,
            backgroundColor: "red",
            color: "white !important",
            borderRadius: "50%",
            minWidth: "28px",
            height: "28px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.875rem",
            fontWeight: "bold",
            boxShadow: 3,
          }}
        >
          {Number(count) > 99 ? "99+" : count}
        </MDBox>
      ) : null}

      <MDBox py={2} display="flex" justifyContent="center">
        <MDBox
          display="grid"
          justifyContent="center"
          alignItems="center"
          bgColor={color}
          color="white"
          width="4rem"
          height="4rem"
          shadow="md"
          borderRadius="lg"
          variant="gradient"
        >
          <Icon fontSize="default">{icon}</Icon>
        </MDBox>
      </MDBox>

      <MDBox pb={2} textAlign="center" lineHeight={1.25}>
        <MDTypography
          variant="h6"
          fontWeight="medium"
          textTransform="capitalize"
        >
          {title}
        </MDTypography>
        {description && (
          <MDTypography variant="button" color="text" fontWeight="regular">
            {description}
          </MDTypography>
        )}
      </MDBox>
    </Card>
  );
}

AlertCards.defaultProps = {
  color: "info",
  count: undefined,
  description: "",
};

AlertCards.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  description: PropTypes.string,
  onClick: PropTypes.func,
};

export default AlertCards;
